import {
  Timestamp,
  collection,
  getDoc,
  getDocs,
  where,
} from "firebase/firestore";
import { useState, useCallback } from "react";
import { Button, Card } from "react-bootstrap";
import { useCollection } from "react-firebase-hooks/firestore";
import DeleteModal from "../components/DeleteBusiness";
import EditLifestyle from "../components/EditLifestyle";
import { Loader } from "../hooks/useLoading";
import { LIFESTYLE } from "../utils/constants";
import {
  // getLifestyleContentDetails,
  lifestyleQuery,
} from "../utils/queryHelpers";
import { useParams } from "react-router-dom";
import {
  getLifestyleDoc,
  getUserDoc,
  lifestyleCollectionRef,
  userCollectionRef,
} from "../utils/firestoreHelpers";
import { useEffect } from "react";
import { app, db, firebaseApp } from "../config/firebase";
import dateFormat, { masks } from "dateformat";

const LifestyleDetail = () => {
  const params = useParams();
  console.log("id :: ", params.id);

  const [content, setContent] = useState({});
  const [usersData, setUsersData] = useState([]);
  const [usersDataNotInterested, setUsersDataNotInterested] = useState([]);
  const [interestType, setInterestType] = useState("interested");

  const getData = async () => {
    try {
      const contentDataRef = await getLifestyleDoc(params.id);
      const contentData = (await getDoc(contentDataRef))?.data() || {};
      console.log("contentData :: ", contentData);
      setContent(contentData);

      const subcollectionRef_interested = collection(
        lifestyleCollectionRef,
        params.id,
        "interested"
      );
      const querySnapshot = await getDocs(subcollectionRef_interested);

      const usersData = [];

      for (const doc of querySnapshot.docs) {
        let userId = doc.data()?.id;
        let userDocRef = getUserDoc(userId);
        let userDataSnapshot = await getDoc(userDocRef);
        // console.log("userDataSnapshot :: ", userDataSnapshot.data());
        if (![undefined, "undefined", null].includes(userDataSnapshot.data())) {
          usersData.push({ ...userDataSnapshot.data(), id: userId });
        }
      }
      setUsersData(usersData);

      // NOT INTERESTED

      const subcollectionRef_not_interested = collection(
        lifestyleCollectionRef,
        params.id,
        "not_interested"
      );
      const querySnapshot1 = await getDocs(subcollectionRef_not_interested);

      const usersData1 = [];

      for (const doc of querySnapshot1.docs) {
        let userId = doc.data()?.id;
        let userDocRef = getUserDoc(userId);
        let userDataSnapshot = await getDoc(userDocRef);
        // console.log("userDataSnapshot :: ", userDataSnapshot.data());
        if (![undefined, "undefined", null].includes(userDataSnapshot.data())) {
          usersData1.push({ ...userDataSnapshot.data(), id: userId });
        }
      }
      setUsersDataNotInterested(usersData1);

      console.log("Users Data:", usersData, usersData1);
    } catch (error) {
      console.error("Error getting data:", error.message);
    }
  };

  useEffect(() => {
    getData();

    return () => {};
  }, []);

  return (
    <>
      <header className="d-flex  justify-content-between mb-3">
        <h4>Lifestyle Content Details - </h4>
      </header>
      <div>
        <div className="w-100 d-flex gap-3 align-items-top">
          <img
            alt=""
            className="w-45 object-fit-cover"
            style={{ maxHeight: "250px" }}
            src={content?.image_url}
          />
          <div className="w-45 d-flex flex-column gap-3">
            <div>Title - {content?.title}</div>
            <div>TYPE - {content?.type}</div>
            <div>LINK - {content?.link}</div>
            <div>
              FROM -{" "}
              {dateFormat(Date(content?.date_from), "dddd, mmmm dS, yyyy")}
            </div>
            <div>
              TO - {dateFormat(Date(content?.date_to), "dddd, mmmm dS, yyyy")}
            </div>
            <div>DESCRIPTION - {content?.description}</div>
            <div>VENUE - {content?.venue}</div>
            <div>TERMS AND CONDITIONS - {content?.tnc}</div>
          </div>
        </div>
      </div>
      <div className="w-100 d-flex justify-content-end mt-3">
        <select onChange={(e) => setInterestType(e.target.value)}
        className="w-full appearance-none px-4 py-2 pr-10 text-sm border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
        >
          <option value="interested">Interested</option>
          <option value="not_interested">Not Interested</option>
        </select>
      </div>
      <div className="mt-3">
        {(interestType === "interested" ? usersData : usersDataNotInterested)
          ?.length ? (
          <>
            <h5>Users input - </h5>
            <table className="table">
              <thead className="table-secondary">
                <tr>
                  <th className=""></th>
                  <th className="">First Name</th>
                  <th className="">Last Name</th>
                  <th className="">Designation</th>
                  <th className="">Email</th>
                  <th className="">Company</th>
                  <th className="">Dial code</th>
                  <th className="">Contact No</th>
                  <th className="">Membership</th>
                </tr>
              </thead>
              <tbody>
                {(interestType === "interested"
                  ? usersData
                  : usersDataNotInterested
                )?.length < 1 ? (
                  <tr>
                    <td colSpan={10} className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : null}
                {(interestType === "interested"
                  ? usersData
                  : usersDataNotInterested
                )?.map((data, index) => {
                  const d = data;
                  const { id } = data;
                  return (
                    <tr key={id}>
                      <td className="">{index + 1}</td>
                      <td className="">{d.first_name}</td>
                      <td className="">{d.last_name}</td>
                      <td className="">{d.designation}</td>
                      <td className="">{d.email}</td>
                      <td className="">{d.company}</td>
                      <td className="">{d.mobile_number_dial}</td>
                      <td className="">{d.mobile_number}</td>
                      <td className="">{d.membership_tier}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        ) : (
          <h2>No users to display</h2>
        )}
      </div>
    </>
  );
};

export default LifestyleDetail;
